(function WebViatorView($, Adzuki)
{
	"use strict";

	$(document).ready(function documentReady()
	{
		Adzuki.onload('/Viator/view/', function onload() {
			var map;// eslint-disable-line no-unused-vars
			var lat;
			var lon;

			// Adzuki.ToggleableSection('[data-toggle="collapse"][data-cookie]');
			$('.adzicon-caret_square_down').click(function expand(e) {
				$(this).toggleClass('fa-caret-square-up');
				$(this).toggleClass('fa-caret-square-down');
			});

			if ($('#map').length) {
				lat = parseFloat($('#map').data('lat'));
				lon = parseFloat($('#map').data('lon'));

				map = new Adzuki.Map('#google_map', {
					lat: lat,
					lng: lon
				});
			}
		});
	});

// custom functions
}(jQuery, window.Adzuki || {}));
